import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Motion, spring, presets } from 'react-motion';

import './termVolume.css';

export default class TermVolume extends Component {

  constructor(props) {
    super(props);

    this.state = { 
      isStatic: !this.props.hidden, 
      counter: this.props.hidden ? 0 : this.props.volume 
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({counter: !nextProps.hidden ? this.props.volume : 0});
  }

  formatSearchVolume(volume) {
    volume = parseInt(volume, 10);
    volume += '';
    var x = volume.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1'.concat(',', '$2'));
    }
    return x1 + x2;
  };

  render() {

     if (this.state.isStatic === true) {
      return (<div className='term-volume'>
        <p className='term-volume__volume'>{this.formatSearchVolume(this.props.volume)}</p>
        <p>average monthly searches</p>
      </div>);
     }

     return (<div className={this.props.hidden ? 'term-volume term-volume--hidden' : 'term-volume animation-slide-up-reveal'}>
       <p className='term-volume__volume'>
         <Motion defaultStyle={{x: 0}} style={{x: spring(this.state.counter, {...presets.stiff, damping: 25, precision: 0.1})}} onRest={this.props.onRevealComplete}>
           {value => <span>{this.formatSearchVolume(value.x)}</span>}
         </Motion>
       </p>
       <p>average monthly searches</p>
     </div>);
   }
}

TermVolume.propTypes = {
  volume: PropTypes.number,
  hidden: PropTypes.bool,
  onRevealComplete: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/term-volume/termVolume.js